import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { BaseComponent } from '../../core/components';
import { CustomerModel } from '../../models';
import { CustomerService } from '../../services';
@Component({
    selector: 'app-customers-create-edit',
    templateUrl: './customers-create-edit.component.html',
    styleUrls: ['../layout/layout.component.scss']
})

export class CustomersCreateEditComponent extends BaseComponent implements OnInit {
    public showSpinner: boolean = false;
    public modalIdData: number;
    public model: any;
    constructor(
        private customerService: CustomerService,
        private route: ActivatedRoute,
        public activeModal: NgbActiveModal,
        private toastr: ToastsManager,
        private router: Router,
        private location: Location) {
        super(router);
    }

    public ngOnInit() {
        this.model = new CustomerModel();
        this.route.params.subscribe((params) => {
            if (!params) {
                return;
            }
            setTimeout(() => {
                const id = params['id'];

                if (id == undefined) {

                    this.loadData(this.modalIdData);
                } else {

                    this.loadData(id);
                }

            }, 1000)

        });
    }

    public loadData(id: number) {
        this.showSpinner = true;
        this.customerService.getCustomer(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                this.model = response.Data;
            });
    }
    public saveChanges() {
        this.showSpinner = true;
        this.customerService.saveCustomer(this.model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                this.activeModal.close("");
            });
    }

    public deleteCustomer() {
        this.showSpinner = true;
        this.customerService.deleteCustomer(this.model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {

                if (!response.Success) {
                    this.toastr.error(response.Message, 'Error');
                }

                this.activeModal.close("");
            });
    }

    closeModal() {
        this.activeModal.close("");
    };
}



// WEBPACK FOOTER //
// ./src/app/components/customers/customers-create-edit.component.ts